import { type AnyAction } from '@reduxjs/toolkit';

import { aiAgentsApi } from 'apis/aiAgents';
import { templatesApi } from 'apis/templates';

/**
 * Maps a MCP tool namespace to the RTK query cache invalidation a mutation in
 * that domain needs. Each one goes through the api owning the tags, so they are
 * type checked against its tag types.
 */
export const NAMESPACE_INVALIDATIONS: Record<string, () => AnyAction> = {
  chatbot: () =>
    aiAgentsApi.util.invalidateTags([
      'AiAgents',
      'AiAgent',
      'AiAgentTools',
      'AiAgentTool',
    ]),
  templates: () => templatesApi.util.invalidateTags(['Templates']),
};
